import { ChipList, ChipListChangeEvent, ChipProps } from '@progress/kendo-react-buttons';
import React from 'react';

interface GenericSettingsMenuProps<TMenuItem, TValue = TMenuItem> {
  menu: TMenuItem[];
  value?: TValue;
  onSelectedMenuItemChanged: (value: TValue) => void;
  className?: string;
  valueField?: string;
  textField?: string;
  chipRenderer?: (chipProps: ChipProps) => React.ReactElement;
}

export const GenericSettingsMenu = <TMenuItem, TValue = TMenuItem>(
  props: GenericSettingsMenuProps<TMenuItem, TValue>
): React.ReactElement => {
  const handleChange = (event: ChipListChangeEvent): void => {
    if (event.value) {
      const valueField = props.valueField;
      if (valueField) {
        const selectedItem = props.menu.find(item => (item as any)[valueField] === event.value);
        if (selectedItem) {
          props.onSelectedMenuItemChanged(selectedItem as TValue);
          return;
        }
      }

      props.onSelectedMenuItemChanged(event.value as TValue);
    }
  };

  return (
    <ChipList
      className={props.className ?? 'helpCenterMenu'}
      selection="single"
      value={props.value}
      onChange={handleChange}
      data={props.menu}
      valueField={props.valueField}
      textField={props.textField}
      chip={props.chipRenderer}
      size="medium"
    />
  );
};
